import { SelectControl } from "../common";
import { useIntl } from "react-intl";
import { edsn_BSPproduct } from "../../openapi/edsn-webapi";

type ProductSelectBspControlProps = {
  label?: string;
  name: string;
  required?: boolean;
};

const ProductBspSelectControl = ({
  label = "product",
  name,
  required,
}: ProductSelectBspControlProps) => {
  const intl = useIntl();
  const options = Object.values(edsn_BSPproduct).map((value) => ({
    value,
    label: intl.formatMessage({ id: `edsn_BSPproduct.${value}` }),
  }));

  return (
    <SelectControl
      name={name}
      label={label}
      options={options}
      required={required}
      isMulti
    />
  );
};

export default ProductBspSelectControl;
